import type { PropsWithChildren } from "react";
import { useState } from "react";

import { ErrorBoundary } from "react-error-boundary";

import { ErrorFallback } from "../components/ErrorFallback";
import type { IWidgetCardLayoutProps } from "../components/WidgetCardLayout";
import { WidgetCardLayout } from "../components/WidgetCardLayout";

import { TrafficSourceTabsContext } from "./traffic-sources-tabs";

export const WidgetCard = ({ children, ...other }: PropsWithChildren<IWidgetCardLayoutProps>) => {
    const tabsContextValue = useState(0);

    const fallback = (
        <ErrorFallback
            {...other}
            minHeight="280px"
        />
    );

    return (
        <ErrorBoundary fallback={fallback}>
            <TrafficSourceTabsContext value={tabsContextValue}>
                <WidgetCardLayout {...other}>{children}</WidgetCardLayout>
            </TrafficSourceTabsContext>
        </ErrorBoundary>
    );
};
